import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { configureApi } from '@kolab/dms-base/api'
import { configureBootstrap } from '@kolab/dms-base/bootstrap'
import App from './App'
import './index.css'

// The tenant is always derived from the URL subdomain
// (e.g. doorpin-dev.talejutech.com → "doorpin-dev") — see dms-base subdomain.ts.
configureBootstrap({ authClient: 'doorpin-bff' })
configureApi({ baseURL: import.meta.env.VITE_API_BASE_URL || '/api' })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
